<template>
  <div class="row">
    <div class="col-12">
      <div class="mb-4"><stats-filter /></div>
      <div v-if="has_data" class="mb-4"><total-chart /></div>
      <div v-if="has_data" class="mb-4"><asr-chart /></div>
      <div v-if="has_data" class="mb-4"><acd-chart /></div>
      <stats-table />
    </div>
  </div>
</template>

<script>
  import StatsTable from './stats-table';
  import AsrChart from './asr-chart';
  import AcdChart from './acd-chart';
  import StatsFilter from './filter/stats-filter';
  import TotalChart from './total/total-chart.vue';
  import { mapGetters } from 'vuex';
  import { DATA } from '@app/plugins/vuex-async-pagginate';

  export default {
    components: { StatsTable, AsrChart, AcdChart, StatsFilter, TotalChart },
    computed: {
      ...mapGetters('pbx/stats/general/table', { items: DATA }),

      has_data: function() {
        try {
          return this.items.length > 0;
        } catch (e) {
          return false;
        }
      }
    }
  };
</script>
